<template>
  <div class="dt-field">
    <date-range-picker :single-date-picker="true" :auto-apply="true" :ranges="false" :append-to-body="true"
      v-model="datePicker" class="dt-date">
      <template #input="picker">
        <span v-if="picker.startDate" class="text-dark">{{ formatDate(picker.startDate) }}</span>
        <span v-else class="text-muted"><i class="bi bi-calendar-event mr-1"></i>Pick date</span>
      </template>
    </date-range-picker>
    <div class="dt-time">
      <select class="custom-select" v-model="hour" :disabled="!date" aria-label="Hour">
        <option v-for="h in hours" :key="h" :value="h">{{ h }}</option>
      </select>
      <span class="px-1">:</span>
      <select class="custom-select" v-model="minute" :disabled="!date" aria-label="Minute">
        <option v-for="m in minutes" :key="m" :value="m">{{ m }}</option>
      </select>
    </div>
  </div>
</template>

<script>
// Date (app date picker) + its own hour / minute dropdowns.
// v-model: 'YYYY-MM-DD HH:mm:ss' or null.
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker';

const pad = n => String(n).padStart(2, '0');

export default {
  name: 'DateTimeField',
  components: { DateRangePicker },
  props: { value: { type: String, default: null }, defaultHour: { type: String, default: '08' } },
  data() {
    return {
      hours: Array.from({ length: 24 }, (_, i) => pad(i)),
      minutes: Array.from({ length: 12 }, (_, i) => pad(i * 5)),
    };
  },
  computed: {
    parsed() { return this.value ? moment(this.value) : null; },
    date() { return this.parsed ? this.parsed.format('YYYY-MM-DD') : null; },
    datePicker: {
      get() { const d = this.parsed ? this.parsed.toDate() : null; return { startDate: d, endDate: d }; },
      set(val) {
        if (!val || !val.startDate) { this.$emit('input', null); return; }
        this.emit(moment(val.startDate).format('YYYY-MM-DD'), this.hour, this.minute);
      },
    },
    hour: {
      get() { return this.parsed ? this.parsed.format('HH') : this.defaultHour; },
      set(h) { if (this.date) this.emit(this.date, h, this.minute); },
    },
    minute: {
      get() {
        if (!this.parsed) return '00';
        return pad(Math.floor(this.parsed.minutes() / 5) * 5);
      },
      set(m) { if (this.date) this.emit(this.date, this.hour, m); },
    },
  },
  methods: {
    formatDate(d) { return moment(d).format('DD MMM YYYY'); },
    emit(date, h, m) { this.$emit('input', `${date} ${h}:${m}:00`); },
  },
};
</script>

<style scoped>
.dt-field { display: flex; align-items: center; gap: 8px; flex-wrap: nowrap; }
.dt-date { flex: 1 1 140px; min-width: 140px; }
.dt-time { display: flex; align-items: center; }
.dt-time { flex: 0 0 auto; }
.dt-time .custom-select { width: auto; }
/* Phones: time drops under the date only when there is no room. */
@media (max-width: 400px) { .dt-field { flex-wrap: wrap; } }
</style>
